'use strict';
import {Observable} from 'rxjs/Observable';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingMode} from '../../core-components/loading-icon/utils';
import {logger} from './logger';


DataTagsManageFilterService.$inject = [
  '$filter',
  'BaseFilterMixin',
];

export function DataTagsManageFilterService(
  $filter,
  BaseFilterMixin,
) {
  return function (vm, $scope) {
    const baseFilter = new BaseFilterMixin($scope, {
      vm: vm,
      filterTemplate: '',
      defaultSortProperty: 'name',
      filterOptions: {},
      enablePagination: true,
      pageSize: 30,
    });

    return {
      size: baseFilter.size,
      updateLimit: baseFilter.updateRenderLimit,
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
      addSubscription: sub => baseFilter.activeSubscriptions.push(sub),
    };

    function initFiltering(list$) {
      baseFilter.registerFilter('filteredList');

      const sortedList$ = list$.map(sortFormList);

      const filteredList$ = Observable.combineLatest(
        sortedList$,
        baseFilter.filterObservable,
        $filter.$filterWithToString)
        .catch(epicErrorHandler(logger, 'filteredList$'));

      baseFilter.activeSubscriptions.push(updateLoadingMode(sortedList$, $scope, vm));

      baseFilter.activeSubscriptions.push(filteredList$.subscribe(baseFilter.updateFilter('filteredList', $scope)));
    }
  };

  function sortFormList(formsAsMap) {
    const formsAsArray = $filter.toArray(formsAsMap);
    return formsAsArray.sort($filter.$sortByProperty('name', true, true)); // todo: verify the correct sort order. param 2
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/filters/DataTagsManageFilter.js